(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["logo"] && !Shopify.designMode) return;
  try {
    function showLogoLeaves() {
    const leaves = document.querySelectorAll(
      ".site-header__shoulder-logo .leaf"
    );
    const tl = gsap.timeline();
    const delay = 0.6;
    // const delay = 2.4;
    tl.delay(delay);
    if (leaves.length === 0) {
      // triggerShowFvItems();
      return;
    }
    leaves.forEach((leaf, index) => {
      tl.fromTo(
        leaf,
        {
          opacity: 0,
          rotate: -16 + (leaves.length - index) * 2.5,
          scale: 1.1,
          filter: "blur(8px)",
        },
        {
          opacity: 1,
          rotate: 0,
          scale: 1.0,
          filter: "blur(0px)",
          duration: 2.8 - 0.1 * index,
          ease: "power3.out",
        },
        0.15 * index
      );
    });
    // triggerShowFvItems();
  }
  window._showLogoLeaves = showLogoLeaves;
  // window._showLogoLeaves();
  } catch(e) { console.error(e); }
})();

})();
